/**
 * Utility function to handle content fallback
 * Takes a content object, default content object, and optionally specific fields to process
 * Returns a new object with content values or default values if content is missing
 */
export const getContentWithFallback = (
  content,
  defaultContent,
  fields = null
) => {
  // If fields not provided, use all keys from defaultContent
  const fieldsToProcess = fields || Object.keys(defaultContent);
  const result = {};

  fieldsToProcess.forEach((field) => {
    result[field] =
      content && content[field] ? content[field] : defaultContent[field];
  });

  return result;
};
